module.exports = __webpack_public_path__ + "img/Billionaire-6.a6294e04.gif";